module.exports = __webpack_public_path__ + "img/5-6-1.d77979a8.png";